import React, { useContext } from "react";
import "../../../assets/css/style.css";

// packages
import styled from "styled-components";
import {
    Navigate,
    Route,
    Routes,
    useLocation,
} from "react-router-dom";

// components
import Fulfill from "../../screens/dashboard/home/Fulfill";
import FindingTherapist from "../../screens/dashboard/FindingTherapist";
import SessionConfirmed from "../../screens/dashboard/home/SessionConfirmed";
import Challenge from "../../screens/dashboard/home/Challenge";
import Explore from "../../screens/dashboard/Explore";
import Statistics from "../../screens/dashboard/Statistics";
import Myaccount from "../../screens/dashboard/account/MyAccount";
import PrivacyPolicy from "../../screens/dashboard/account/PrivacyPolicy";
import TermsAndCondition from "../../screens/dashboard/account/TermsAndCondition";
import Faq from "../../screens/dashboard/account/Faq";
import VideoPlayer from "../../includes/modals/Video";
import Describe from "../../screens/dashboard/home/Describe";
import Schedule from "../../screens/dashboard/home/Schedule";
import MoreModal from "../../includes/modals/MoreModal";
import MeditateHome from "../../screens/dashboard/meditate/MeditateHome";
import Page404 from "../../general/Page404";
import DashboardPage from "../../screens/dashboard/DashboardPage";
import PrivateRoute from "../routes/PrivateRoute";
import SessionRoute from "../routes/SessionRoute";
import SessionIndividualPage from "../../includes/homescreens/SessionIndividualPage";
import { Context } from "../../../contexts/Store";
import CancelSession from "../../screens/dashboard/home/CancelSession";
import About from "../../screens/dashboard/account/About";
import Notification from "../../screens/dashboard/notification/Notification";
import ComingSoon from "../../general/ComingSoon";
import SummaryReport from "../../includes/homescreens/SummaryReport";
import RefundPolicy from "../../screens/dashboard/account/RefundPolicy";
import { THEME_COLORS } from "../../../ThemeConfig";
import Transactions from "../../screens/dashboard/account/Transactions";

export default function HomeRouter({
    getNotifications,
    isExistingSession,
    isASessionAccepted,
    setIsASessionAccepted,
    acceptedSessionData,
    acceptedSessionIds,
    isAcceptedModalOpen,
    setIsAcceptedModalOpen,
    isPaymentPending,
}) {
    const { state } = useContext(Context);
    const location = useLocation();

    // const extractIdFromPath = (path) => {
    //     const parts = path.split("/");
    //     const lastPart = parts[parts.length - 1];
    //     return lastPart ? lastPart : null;
    // };
    const extractIdFromPath = (path) => {
        // Remove any trailing slashes from the path
        const cleanedPath = path.replace(/\/+$/, "");
        // console.log(cleanedPath, "cleanedPath");
        const parts = cleanedPath.split("/");
        const lastPart = parts[parts.length - 1];
        return lastPart ? lastPart : null;
    };

    const idFromPath = extractIdFromPath(location.pathname);
    // console.log(isExistingSession, "isExistingSession");

    const path = [
        "/dashboard",
        "/describe",
        "/schedule",
        "/fulfill",
        "/finding-therapist",
        "/session-confirmed",
        "/home",
        "/meditate",
        "/explore",
        "/statistics",
        "/account",
        "/privacy-policy",
        "/terms-and-conditions",
        "/transaction-history",
        "/refund-policy",
        "/faq",
        "/about-us",
        "/video",
        "/more",
        "/homepage",
        "/create-session",
        "/notifications",
        "/payment",
        `/session/${idFromPath}`,
        `/view-summary-report/${idFromPath}`,
        `/cancel-session/${idFromPath}`,
        `/payment/${idFromPath}`,
    ];
    // Check if the current location is included in the defined paths
    // const renderComponent = path.includes(location.pathname);
    const renderComponent = path.some((p) => {
        const trimmedPathname = location.pathname.replace(/\/+$/, ""); // Trim trailing slashes
        const trimmedPath = p.replace(/\/+$/, ""); // Trim trailing slashes
        return trimmedPathname === trimmedPath;
    });
    return (
        <>
            <Container className={renderComponent ? "" : "none"}>
                <ContentWrapper className={renderComponent ? "" : "none"}>
                <Routes>
                    {/* Dashboard (logged-in home) - new UI matching landing */}
                    <Route
                        exact
                        path="/dashboard"
                        element={
                            <SessionRoute>
                                <DashboardPage
                                    isExistingSession={isExistingSession}
                                    isASessionAccepted={isASessionAccepted}
                                    setIsASessionAccepted={
                                        setIsASessionAccepted
                                    }
                                />
                            </SessionRoute>
                        }
                    />

                    <Route
                        exact
                        path="/payment/:paymentId" //payment id
                        element={
                            <SessionRoute>
                                <DashboardPage
                                    isASessionAccepted={isASessionAccepted}
                                    setIsASessionAccepted={
                                        setIsASessionAccepted
                                    }
                                />
                            </SessionRoute>
                        }
                    />
                    <Route
                        exact
                        path="/create-session"
                        element={
                            <PrivateRoute>
                                <Challenge />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        exact
                        path="/describe"
                        element={
                            <PrivateRoute>
                                <Describe />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        exact
                        path="/schedule"
                        element={
                            <PrivateRoute>
                                <Schedule />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        exact
                        path="/fulfill"
                        element={
                            <PrivateRoute>
                                <Fulfill />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        exact
                        path="/transaction-history"
                        element={
                            <PrivateRoute>
                                <Transactions />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        exact
                        path="/cancel-session/:id"
                        element={
                            <PrivateRoute>
                                <CancelSession />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        exact
                        path="/notifications"
                        element={
                            <PrivateRoute>
                                <Notification
                                    getHeaderNotifications={getNotifications}
                                    // isExistingSession={isExistingSession}
                                />
                            </PrivateRoute>
                        }
                    />
                    {/* <Route
                        exact
                        path="/finding-therapist"
                        element={<FindingTherapist />}
                    /> */}
                    <Route
                        exact
                        path="/session-confirmed"
                        element={<SessionConfirmed />}
                    />
                    <Route exact path="/meditate" element={<MeditateHome />} />
                    <Route exact path="/explore" element={<Explore />} />
                    <Route
                        exact
                        path="/session/:id"
                        element={
                            <PrivateRoute>
                                <SessionIndividualPage />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        exact
                        path="/view-summary-report/:id"
                        element={
                            <PrivateRoute>
                                <SummaryReport />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        exact
                        path="/statistics"
                        element={
                            <PrivateRoute>
                                <Statistics />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        exact
                        path="/account"
                        element={
                            <PrivateRoute>
                                <Myaccount />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        exact
                        path="/privacy-policy"
                        element={<PrivacyPolicy />}
                    />
                    <Route
                        exact
                        path="/terms-and-conditions"
                        element={<TermsAndCondition />}
                    />
                    <Route
                        exact
                        path="/refund-policy"
                        element={<RefundPolicy />}
                    />
                    <Route exact path="/faq" element={<Faq />} />
                    <Route exact path="/video" element={<VideoPlayer />} />
                    <Route exact path="/more" element={<MoreModal />} />
                    <Route exact path="/404" element={[<Page404 />]} />
                    <Route exact path="/coming-soon" element={<ComingSoon />} />
                    <Route exact path="*" element={<Navigate to="/404" />} />
                </Routes>
                </ContentWrapper>
            </Container>
        </>
    );
}

const Container = styled.section`
    display: block;
    min-height: calc(100vh - 70px);
    &.none {
        display: block;
    }
`;
const ContentWrapper = styled.main`
    width: 100%;
    max-width: 100%;
    min-height: calc(100vh - 70px);
    overflow-x: hidden;
    overflow-y: auto;
    background: ${THEME_COLORS.page_bg};
    box-sizing: border-box;
    &.none {
        display: block;
    }
`;
